import { StepIconProps } from '@mui/material';
import { TickIcon } from '../../icons/TickIcon';
import { ActiveCircleIcon } from '../../icons/ActiveCircleIcon';
import { CircleIcon } from '../../icons/CircleIcon';

export function BrightyStepIcon(props: StepIconProps) {
  const { active, completed } = props;

  if (completed) {
    return <TickIcon />;
  }

  if (active) {
    return <ActiveCircleIcon color="info" />;
  }

  return <CircleIcon />;
}
